import { ForgotPasswordResponse, SignInPayload, SignInResponse } from "../../models/auth.model";
import axios from "axios";
import { BASE_URL } from "../../constants/api";
import axiosService from "../../services/axios/axios.service";

export const signIn = async (
  payload: SignInPayload
): Promise<NonNullable<SignInResponse>> => {
  const response = await axios.post(`${BASE_URL}/auth/login`, payload);
  return response.data;
};

export const loginWithToken = async (): Promise<NonNullable<SignInResponse>> => {
  const response = await axiosService.post(`/auth/login-with-token`, {});
  return response.data;
};

export const forgotPassword = async (email: string): Promise<NonNullable<ForgotPasswordResponse>> => {
  const response = await axios.post(`${BASE_URL}/auth/forgot-password`, { email });
  return response?.data?.data;
};

export const verifyForgotPassword = async (email: string, otp: string, password: string): Promise<NonNullable<any>> => {
  const response = await axios.post(`${BASE_URL}/auth/verify-forgot-password`, { email, otp, password });
  return response?.data;
};

export const logout = async (): Promise<NonNullable<any>> => {
  const response = await axiosService.post(`/auth/logout`, {});
  return response;
};